// Sorts array by passed property
const sortBy = (property) => {
  return (a, b) => {
    const objA = a.properties[property]
    const objB = b.properties[property]
    if (objA < objB) {
      return -1
    }
    if (objA > objB) {
      return 1
    }
    return 0
  }
}

export default sortBy